import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-value-added-content',
    templateUrl: './value-added-content.component.html',
    styleUrls: ['./value-added-content.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ValueAddedContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
